export const SET_SC_SELECTED_ACCOUNTS = 'SET_SC_SELECTED_ACCOUNTS';
export const setSCSelecteAccounts = (domains: ICompanyOption[]) => ({
  type: SET_SC_SELECTED_ACCOUNTS,
  payload: domains,
});

export const CLEAR_DOMAINS = 'CLEAR_DOMAINS';
export const clearDomains = () => ({
  type: CLEAR_DOMAINS,
});

export interface ICompanyOption {
  domain: string;
  name: string | null;
  id: number;
  isDummyDomain?: boolean;
  linkedinUrl?: string;
}

const initialState: ICompanyOption[] = [];

interface Action {
  type: string;
  payload?: ICompanyOption[];
}

const scSelectedAccountsReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_SC_SELECTED_ACCOUNTS:
      return [...action.payload!];

    case CLEAR_DOMAINS:
      return [];

    default:
      return state;
  }
};

export default scSelectedAccountsReducer;
